module.exports = __webpack_public_path__ + "media/icons/smartsearch/materials/ti-501435e0b5ac0481c41c191bbb876dc2.png";